/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InvestmentProposal from './InvestmentProposal';

/**
 * The PaginatedInvestmentProposalsResponse model module.
 * @module model/PaginatedInvestmentProposalsResponse
 * @version 1.0.0
 */
class PaginatedInvestmentProposalsResponse {
    /**
     * Constructs a new <code>PaginatedInvestmentProposalsResponse</code>.
     * @alias module:model/PaginatedInvestmentProposalsResponse
     */
    constructor() { 
        
        PaginatedInvestmentProposalsResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedInvestmentProposalsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedInvestmentProposalsResponse} obj Optional instance to populate.
     * @return {module:model/PaginatedInvestmentProposalsResponse} The populated <code>PaginatedInvestmentProposalsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedInvestmentProposalsResponse();

            if (data.hasOwnProperty('total_count')) {
                obj['total_count'] = ApiClient.convertToType(data['total_count'], 'Number');
            }
            if (data.hasOwnProperty('current_page')) {
                obj['current_page'] = ApiClient.convertToType(data['current_page'], 'Number');
            }
            if (data.hasOwnProperty('per_page')) {
                obj['per_page'] = ApiClient.convertToType(data['per_page'], 'Number');
            }
            if (data.hasOwnProperty('investment_proposals')) {
                obj['investment_proposals'] = ApiClient.convertToType(data['investment_proposals'], [InvestmentProposal]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedInvestmentProposalsResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedInvestmentProposalsResponse</code>.
     */
    static validateJSON(data) {
        if (data['investment_proposals']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['investment_proposals'])) {
                throw new Error("Expected the field `investment_proposals` to be an array in the JSON data but got " + data['investment_proposals']);
            }
            // validate the optional field `investment_proposals` (array)
            for (const item of data['investment_proposals']) {
                InvestmentProposal.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * 全投資提案数
 * @member {Number} total_count
 */
PaginatedInvestmentProposalsResponse.prototype['total_count'] = undefined;

/**
 * 現在のページ
 * @member {Number} current_page
 */
PaginatedInvestmentProposalsResponse.prototype['current_page'] = undefined;

/**
 * 1ページあたりの件数
 * @member {Number} per_page
 */
PaginatedInvestmentProposalsResponse.prototype['per_page'] = undefined;

/**
 * @member {Array.<module:model/InvestmentProposal>} investment_proposals
 */
PaginatedInvestmentProposalsResponse.prototype['investment_proposals'] = undefined;






export default PaginatedInvestmentProposalsResponse;

